import React, { useState, useRef, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectProps } from '@material-ui/core';
import { useStyles } from './style';

interface SelectFieldProps extends SelectProps {
  inputLabel: string;
  options: string[];
  onInputChange: (value: string) => void;
}
export default function SelectField(props: SelectFieldProps) {
  const selectFieldStyles = useStyles();

  const inputLabelRef = useRef<HTMLLabelElement>(null);
  const [inputLabelWidth, setInputLabelWidth] = useState(0);

  const { inputLabel, options, onInputChange, value, ...rest } = props;

  useEffect(() => {
    setInputLabelWidth(inputLabelRef.current!.offsetWidth);
  }, [setInputLabelWidth]);

  return (
    <FormControl variant='outlined' className={selectFieldStyles.formControl}>
      <InputLabel ref={inputLabelRef} shrink>
        {inputLabel}
      </InputLabel>
      <Select
        variant='outlined'
        labelWidth={inputLabelWidth}
        value={value || options[0]}
        onChange={e => onInputChange(e.target.value as string)}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
        {...rest}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
